/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserInfoDto = {
    salutation: UserInfoDto.salutation;
    phoneNumber: string;
    readonly userId?: string;
    readonly givenName?: string;
    readonly familyName?: string;
    readonly email?: string;
    readonly issuedAt?: string;
    readonly expiresAt?: string;
    readonly authorizationGroup?: Array<string>;
    readonly entitlementGroup?: Array<string>;
    readonly hasActiveCompanyInCrisp?: boolean;
};
export namespace UserInfoDto {
    export enum salutation {
        MR = 'MR',
        MRS = 'MRS',
        OTHER = 'OTHER',
    }
}

